// import gsap from 'gsap';
// import { useGSAP } from '@gsap/react';
// import { smallHeroVideo } from '../utils';
// import { useEffect, useState } from 'react';
// import heroVideo from "../../public/assets/videos/hero3.mp4";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react"; 
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";

const Hero = () => {
  // const [videoSrc, setVideoSrc] = useState(window.innerWidth < 760 ? heroVideo : heroVideo)

  // const handleVideoSrcSet = () => {
  //   if(window.innerWidth < 760) {
  //     setVideoSrc(smallHeroVideo)
  //   } else {
  //     setVideoSrc(heroVideo)
  //   }
  // }

  // useEffect(() => {
  //   window.addEventListener('resize', handleVideoSrcSet);

  //   return () => {
  //     window.removeEventListener('reisze', handleVideoSrcSet)
  //   }
  // }, [])

  // useGSAP(() => {
  //   gsap.to('#hero', { opacity: 1, delay: 2 })
  //   gsap.to('#cta', { opacity: 1, y: -50, delay: 2 })
  // }, [])

  return (
    <section className="relative w-full h-screen overflow-hidden">
    {/* Fullscreen Video Background */}
    <video
      className="absolute top-0 left-0 w-full h-full object-cover  z-0"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      poster="/assets/images/banner.jpg"
      key="https://cdn.jsdelivr.net/gh/haidrbukhari/my-assets@main/hero.mp4"
    >
      <source src="https://cdn.jsdelivr.net/gh/haidrbukhari/my-assets@main/hero.mp4" type="video/mp4" />
    </video>
  
    {/* House-Shaped Overlay Content */}
    
    <div className="relative z-10 w-full h-full flex justify-center items-center px-4">
      <div className="house-shape bg-slate-900/80 text-slate-100 p-6 sm:p-10 flex flex-col items-center text-center w-full max-w-md sm:max-w-xl">
      <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.3, delay:1 }}
                viewport={{ once: true }}>
        <h1 className="text-2xl sm:text-4xl font-bold mb-4 sm:mb-6 pt-20 sm:pt-20">Transforming Homes with Quality Craftsmanship</h1>
        <p className="text-base sm:text-xl leading-relaxed mb-6">
        We specialize in kitchen renovations, house extensions, attic conversions, skimming, flooring, bathroom renovations, and tiling services. From modern upgrades to complete property transformations, we deliver high-quality workmanship tailored to your vision.
     
          
         
        </p>
        <div className="flex justify-center">
        <Link to="/contact">
            <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-600 shadow-xl text-lg group">
              <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
              <span className="relative z-10">Contact Us</span>
            </button>
            </Link>
      </div>
        </motion.div>
      </div>
    </div>
  
    {/* Custom House Shape CSS */}
    <style jsx>{`
      .house-shape {
        clip-path: polygon(
          50% 0%,
          100% 25%,
          100% 100%,
          0% 100%,
          0% 25%
        );
      }
  
      @media (max-width: 640px) {
        .house-shape {
          width: 100%;
          max-width: 90%;
          padding: 1.5rem;
        }
      }
    `}</style>
  </section>
  
  
  

  )
}

export default Hero